'use client';
import { InputHTMLAttributes, useEffect, useRef, useState } from 'react';
import { countriesMeta } from '../../utils/flags';
import { twMerge } from 'tailwind-merge';
import Arrow from './svg/Arrow';
import RequiredFieldStar from './svg/RequiredFieldStar';
import Image from 'next/image';

export default function TextField(props: Partial<InputHTMLAttributes<any>> & {regex?: string; country?: typeof countriesMeta[0]; phoneKey?: string; countryKey?: string;}) {
  const [menuExpanded, setMenuExpanded] = useState(false);
  const toggleMenu = (open: boolean) => setMenuExpanded(open);
  const menuRef = useRef<any>();
  const countrySelectorRef = useRef<any>();
  const handleClick = (e: any) => {
    if (countrySelectorRef && countrySelectorRef.current.contains(e.target) && menuExpanded) return;
    if (menuRef && menuExpanded && !menuRef.current?.contains(e.target)) toggleMenu(false);
  }

  useEffect(() => {
    if (props.country) window.addEventListener('mousedown', handleClick);
    return () => {
      if (props.country) window.removeEventListener('mousedown', handleClick);
    }
  })
  return (
    <div className={twMerge('flex w-full items-center gap-[5px] [&>*]:px-[24px] [&>*]:py-[5px] [&>*]:bg-primaryReal-500 dark:[&>*]:bg-primaryReal-600 [&>*]:rounded-[10px] [&>*]:relative [&>*]:h-[76px] tablet:col-span-full desktop:col-span-1', props.country && '[&>*:first-child]:rounded-l-none [&>*:last-child]:rounded-r-none')}>
    <div className={twMerge('flex flex-1 items-center justify-between  w-full gap-[12px]', props.className)}>
    
      <input
        {...props}
        onChange={(e) => {
          const {value, name} = e.target;
          if (props.regex && value) {
            const regex = new RegExp(props.regex);
            if (!regex.test(value)) return;
          }
          // @ts-ignore
          props.onChange!({[name]: value});
        }}
        className='bg-transparent border-none outline-none w-full h-full text-black dark:text-white'
        />
      {props.required && <RequiredFieldStar className='flex-shink-0'/>}
      </div>
        {props.country && (
                <div ref={countrySelectorRef} className='h-full w-fit relative flex gap-[6px] items-center justify-center cursor-pointer' onClick={() => toggleMenu(!menuExpanded)}>
                  <Arrow className={twMerge('dark:[&>*]:stroke-white transition-transform duration-200 rotate-0 [&>*]:flex-shrink-0', menuExpanded && 'rotate-180')}/>
                  <div className='place-items-center h-[24px] w-[35px] relative hidden tablet:grid'>
                    <Image src={props.country.image!} alt={props.country.name!} fill sizes='0vw' loading='lazy'/>
                  </div>
                  <span className='whitespace-nowrap text-[14px]'>{props.country!.phone[0]}</span>
                  {menuExpanded && (
                    <div ref={menuRef} className='absolute bottom-0 left-0 translate-y-[100%] border-[1px] border-primaryReal-100 rounded-[5px] h-[250px] overflow-y-auto z-10 bg-white dark:bg-primaryReal-100 dark:border-primaryReal-300 w-[150px] flex flex-col'>
                      {countriesMeta.sort((a,b) => a.name.localeCompare(b.name)).map(f => {
                        return (
                        <div className={twMerge('flex items-center gap-[6px] border-b-[1px] border-b-primaryReal-400 hover:bg-gray-100 dark:hover:bg-primaryReal-600 px-[12px] py-[12px]', props.country!.name === f.name && 'bg-gray-200 dark:bg-primaryReal-300')} onClick={() => {
                          // const event = new Event('change');
                          // Object.defineProperty(event, "target", {
                          //   writable: true,
                          //   value: {name: 'country', value: f},
                          // });
                          // @ts-ignore
                          props.onChange({[props.phoneKey || 'phone']: '', [props.countryKey || 'country']: f});
                          setMenuExpanded(false);
                        }}>
                         <Image height={24} width={35} src={f.image!} alt={f.name!} loading='lazy'/>
                         <span>{f.phone?.[0] || ''}</span> 
                        </div>
                        )
                      })}
                    </div>
                  )}
        
                </div>
              )}
    
        </div>
  )
}
